<template>
  <div>
    <v-alert v-if="param.instructions" type="info">
      <div v-html="param.instructions"></div>
    </v-alert>
    <component
      :is="inputType"
      outlined
      dense
      :label="param.name"
      v-model="param.value"
    ></component>
  </div>
</template>
<script>
import DateRangePicker from "@/components/DateRangePicker.vue";
import { VTextField } from "vuetify/lib";

export default {
  name: "ParameterInput",
  components: { DateRangePicker },
  props: {
    param: {
      type: Object,
      required: true
    }
  },
  computed: {
    inputType() {
      if (this.param.type === "text") {
        return VTextField;
      }
      if (this.param.type === "date") {
        return DateRangePicker;
      }
      return VTextField;
    }
  },
  created() {
    if (this.param.default && (!this.param.value || this.param.value === "")) {
      this.param.value = this.param.default;
    }
  }
};
</script>

<style scoped lang="scss">
.v-application .v-alert {
  color: white;
  font-size: 16px;
  font-weight: 300;

  &.theme--dark {
    ::v-deep a {
      color: white;
    }
  }
}
.v-alert__icon.v-icon {
  align-self: unset !important;
}
</style>
